import React from "react";
import { Dialog, DialogActions, DialogTitle, Button } from "@material-ui/core";
import IntlMessages from "util/IntlMessages";

const DeleteLedaga = ({ open, handleRequestClose, handleDelete }) => {
  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      disableBackdropClick
      onClose={handleRequestClose}
    >
      <DialogTitle>
        <IntlMessages id="additionalMedications.MsgDelConfirmation" />
      </DialogTitle>
      <DialogActions>
        <Button onClick={handleRequestClose} color="secondary">
          <IntlMessages id="core.cancel" />
        </Button>
        <Button onClick={handleDelete} color="primary">
          <IntlMessages id="core.accept" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteLedaga;